class BooleanOrNullOrUndefinedClass {
  value: unknown;

  constructor(value?: unknown) {
    this.value = value;
  }

  static from<T>(value?: T): boolean | undefined {
    return value === undefined
      ? undefined
      : value === null
      ? undefined
      : typeof value === 'string'
      ? Boolean(value.toLowerCase() === 'true')
      : Boolean(value);
  }
}

// Declarar la interfaz y el constructor
interface BooleanOrNullOrUndefinedConstructor {
  new (value?: unknown): BooleanOrNullOrUndefinedClass;
  (value?: unknown): boolean | undefined;
  readonly prototype: BooleanOrNullOrUndefinedClass;
}

const BooleanOrNullOrUndefinedFunction = function (
  this: unknown,
  value?: unknown
) {
  if (this instanceof BooleanOrNullOrUndefinedFunction) {
    return new BooleanOrNullOrUndefinedClass(value);
  } else {
    return BooleanOrNullOrUndefinedClass.from(value);
  }
};

BooleanOrNullOrUndefinedFunction.prototype =
  BooleanOrNullOrUndefinedClass.prototype;
export const BooleanOrNullOrUndefined: BooleanOrNullOrUndefinedConstructor =
  BooleanOrNullOrUndefinedFunction as BooleanOrNullOrUndefinedConstructor;
